import { Selectable } from '../../interface/selectable';
import { CheckState } from '../../enum/check-state.enum';

export class GroupEntities<T extends Selectable> implements Selectable {
  public get checkState(): CheckState {
    if (this.entities) {
      const count = this.entities.filter((item) => item.check).length;
      switch (count) {
        case 0:
          return CheckState.uncheck;
        case this.entities.length:
          return CheckState.check;
        default:
          return CheckState.partial;
      }
    }
    return this.check ? CheckState.check : CheckState.uncheck;
  }

  get items(): T[] {
    return this.entities;
  }

  public _check;
  get check(): boolean {
    return this._check;
  }
  set check(value: boolean) {
    this.entities.forEach((row) => (row.check = value));
  }
  public id: string;
  public label: string;
  public entities: T[];

  constructor(id: string, label: string, entities: T[]) {
    this.id = id;
    this.label = label;
    this.entities = entities;
  }

  public enable = true;
  icon: string;
  iconColor: string;
  normalizedText: string;

  compare(item: any): number {
    throw new Error('Method not implemented.', item);
  }

  public push(entity: T) {
    this.entities.push(entity);
  }

  public toString(): string {
    return this.label;
  }
}
